const storageKey = "clickandgo_locale";
const cookieKey = "clickandgo_locale";

function getCookie(name) {
  return document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${name}=`))
    ?.split("=")[1];
}

function setLocalePreference(locale) {
  localStorage.setItem(storageKey, locale);
  document.cookie = `${cookieKey}=${locale}; path=/; max-age=31536000; SameSite=Lax`;
}

function getAlternateUrl(locale) {
  const link = document.querySelector(`link[rel="alternate"][hreflang="${locale}"]`);
  if (!link) {
    return "";
  }

  try {
    return new URL(link.href, window.location.origin).pathname;
  } catch {
    return link.getAttribute("href") || "";
  }
}

function detectPreferredLocale() {
  const stored = localStorage.getItem(storageKey) || getCookie(cookieKey);
  if (stored === "fr" || stored === "en") {
    return { locale: stored, explicit: true };
  }

  const browserLocales = navigator.languages || [navigator.language || "fr"];
  const browserLocale = browserLocales.find(Boolean)?.toLowerCase() || "fr";
  return { locale: browserLocale.startsWith("en") ? "en" : "fr", explicit: false };
}

document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;
  const currentLocale = body.dataset.locale || document.documentElement.lang || "fr";
  const preferred = detectPreferredLocale();

  if (preferred.locale !== currentLocale) {
    const target = getAlternateUrl(preferred.locale);
    if (target && window.location.pathname !== target) {
      if (!preferred.explicit) {
        setLocalePreference(preferred.locale);
      }
      window.location.replace(target);
      return;
    }
  }

  document.querySelectorAll("[data-locale-link]").forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();

      const nextLocale = link.getAttribute("data-locale-link");
      if (!nextLocale || nextLocale === currentLocale) {
        return;
      }

      setLocalePreference(nextLocale);
      const target = getAlternateUrl(nextLocale) || link.getAttribute("href");
      if (target) {
        window.location.href = target;
      }
    });
  });
});
